// Card used extensively throughout site
import { Box, Card, CardContent, CardMedia, Typography, useMediaQuery, useTheme } from "@mui/material";
import { sanitizeHTML } from "../Utils/formattingUtils";

interface CustomCardProps {
    posts: any[];
  }

export const CustomCard = (props: CustomCardProps) => {
    const { posts } = props;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            {posts.map((post, index) => (
                <Card key={index} sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', width: '100%', marginBottom: 2 }}>
                    {post.image && <CardMedia
                        component="img"
                        sx={{ width: isMobile ? '100%' : 300 }}  // Adjust as needed
                        image={post.image}
                        alt={post.title}
                    />}
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <CardContent>
                            <Typography variant="h5" style={{ textAlign: post.centerTitle ? 'center' : 'left' }}>
                                {post.title}
                            </Typography>
                            <Typography
                                variant="body1"
                                dangerouslySetInnerHTML={sanitizeHTML(post.content)}
                            />                           
                        </CardContent>
                    </Box>
                </Card>
            ))}
        </>
    )
}